<template lang="pug">
q-dialog(
    :model-value="showDrugstore"
    position="bottom"
    transition-show="slide-up"
    transition-hide="slide-down"
    seamless
    full-width)
    .full-width.bg-secondary.b-radius-0.mobile-drugstore.relative-position(:class="addressChoose ? 'q-py-lg' : 'q-py-md'")
        base-full-spinner(
            v-if="loading")
            template(v-slot:spinner)
                q-spinner-dots(
                    size="40px"
                    color="positive")
        .row.absolute-top-right.q-pt-sm.q-pr-sm
            q-btn(
                flat
                round
                fab-mini
                v-close-popup
                @click="$emit('hide')")
                q-icon(
                    name="etabl:cross"
                    size="xs"
                    color="grey-4")
        .row.justify-center(v-if="appointment && drugstore.isReceptionAvailable")
            base-btn(
                bradius="16"
                height="32"
                width="178"
                font_size="14"
                color="positive"
                label="Выбрать этот салон"
                @click="setDrugstore")
        .row.justify-center(v-if="addressChoose")
            base-btn(
                bradius="16"
                height="32"
                width="178"
                font_size="14"
                color="positive"
                label="Искать в этой аптеке"
                @click="setAddress")
        .row.justify-center.text-grey-9.text-weight-medium(v-if="appointment && !drugstore.isReceptionAvailable")
            | Запись недоступна
        .q-px-md
            .row.q-mb-md.items-center
                q-img(
                    v-if="drugstore.brandUrl"
                    :src="drugstore?.brandUrl"
                    style="max-width: 85px; height: 44px"
                    fit="contain"
                )
                q-img(
                    v-else
                    src="logo_t.t.svg"
                    style="max-width: 85px; height: 44px"
                    fit="contain"
                )
                .font-16.text-weight-600.q-ml-md
                    | {{ drugstore?.title ? drugstore?.title : 'Табле.Точка' }}
            .text-weight-medium(v-if="drugstore.city?.name") {{ drugstore.city?.name }}
            .text-weight-medium.q-mt-lg.q-mb-sm(v-if="addressChoose") Пункт выдачи
            template(v-if="!appointment")
                div(:class="addressChoose ? 'text-primary' : 'text-positive'") {{ formatAddress(drugstore.geo.address) }}
            .app-primary(v-else) {{ formatAddress(drugstore.address) }}
            div(v-if="!appointment && !addressChoose")
                strong.text-positive(:class="addressChoose ? 'q-mt-sm' : ''" v-if="!currentDrugstoreSchedule") Круглосуточно
        q-expansion-item(
            v-if="currentDrugstoreSchedule && !appointment"
            v-model="isExpanded"
            :label="currentDrugstoreSchedule"
            :class="addressChoose ? 'q-mt-sm' : ''")
            q-scroll-area(
                :horizontal-thumb-style="{display: 'none'}"
                style="height: 70px; width: 100%;max-width: 600px"
            )
                .row.q-px-xs.no-wrap
                    .day.q-pa-xs.text-center(
                        v-for="(day, index) in drugstore.schedule"
                        :key="index"
                        :class="day.day === today ? 'bordered-positive b-radius-8' : ''"
                        :style="day.day === today ? 'background-color: rgba(231, 247, 232, 0.4)' : ''")
                        .text-positive.font-14 {{ day.dayName }}
                        .text-primary.font-12 {{ day.start }}
                        .text-primary.font-12 {{ day.end }}
                        .text-primary.font-12(v-if="!day.start") Вых.

        .q-px-md(v-for="item in products" :key="item.id")
            template(v-if="drugstore.drugstore_price && item.priceNew !== 0")
                span.text-positive.text-weight-600.font-14
                    | В аптеке {{ drugstore.drugstore_price }} ₽
                span.text-grey |
                span.text-yellow-6.text-weight-600.font-14
                    | Со склада {{ new Intl.NumberFormat('ru-RU').format(item.priceNew).replace(',','.') }} ₽
            template(v-else-if="drugstore.drugstore_price && item.priceNew === 0")
                span.text-positive.text-weight-600.font-14
                    | В аптеке {{ drugstore.drugstore_price }} ₽
            template(v-else-if="!drugstore.drugstore_price && item.priceNew !== 0")
                span.text-yellow-6.text-weight-600.font-14
                    | Со склада {{ new Intl.NumberFormat('ru-RU').format(item.priceNew).replace(',','.') }} ₽
            template(v-if="drugstore.drugstoreBalanceText")
                .row.text-weight-600.q-mt-sm
                    span.q-mr-xs Наличие:
                    span  {{ drugstore.drugstoreBalanceText }}
        .q-px-md
            base-btn.q-mt-md(
                :label="'Маршрут'"
                :height="'40'"
                :background="'transparent'"
                :text_color="'positive'"
                :outline="true"
                :icon="'near-me'"
                :icon_color="'positive'"
                font_size="14"
                bradius="16"
                centred
                :gapLabel="'8px'"
                @click="getRouteToPharmacy(drugstore.geo.location)"
            )
</template>

<script>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import BaseBtn from 'components/Base/BaseBtn.vue';
import BaseFullSpinner from 'components/Base/BaseFullSpinner.vue';
import MapProductMobile from 'components/MapProduct/MapProductMobile.vue';

export default {
    name: 'DrugstoreMobile',
    emits: ['hide'],
    components: {
        BaseBtn,
        BaseFullSpinner,
        MapProductMobile,
    },
    props: {
        drugstore: {
            type: Object,
            required: true,
        },
        currentProduct: {
            type: Object,
            default: () => null,
        },
        showDrugstore: {
            type: Boolean,
            default: () => false,
        },
        products: {
            type: Array,
        },
        basket: {
            type: Boolean,
        },
        notAvailableProducts: {
            type: Array,
            default: () => [],
        },
        appointment: {
            type: Boolean,
            default: () => false,
        },
        addressChoose: {
            type: Boolean,
            default: () => false,
        },
    },
    setup(props, { emit }) {
        const store = useStore();
        // состояние загрузки
        const loading = ref(false);

        // отображение режимов работы аптеки
        const isExpanded = ref(!props.addressChoose);

        const formatAddress = (address) => {
            if (!address) return '';

            return address
                .split(',')
                .map(part => part.trim())
                .filter(part => {
                    if (/обл(асть|асти)?|край|респ(ублика)?|АО/iu.test(part)) {
                        const isAdminUnit =
                            !/\d/.test(part) &&
                            !/(ул|улица|пр|проспект|д|дом|пер|переулок|б-р|бульвар)/iu.test(part) &&
                            part.length < 50;

                        if (isAdminUnit) {
                            return false;
                        }
                    }

                    return true;
                })
                .join(', ');
        };

        const today = computed(() => new Date().getDay() ?? 7);

        // значение "забрать сегодня"
        const isToday = computed(() => store.getters['basket/BASKET_IS_TODAY']);

        // время работы выбранной аптеки
        const currentDrugstoreSchedule = computed(() => {
            if (props.drugstore.isDayAndNight) {
                return 'Круглосуточно';
            }

            let day;

            if (props.drugstore.schedule?.length)
                day = props.drugstore.schedule
                    .find((item) => item.day === today.value);

            if (props.drugstore.schedules?.length)
                day = props.drugstore.schedules
                    .find((item) => item.dayNumber === today.value);

            if (day && props.appointment) {
                if (!day.workingTime.begin) {
                    return 'Выходной';
                }
                if (day.workingTime.begin == '00:00') {
                    return false;
                } else {
                    return `Сегодня ${day.workingTime.begin} - ${day.workingTime.end}`;
                }
            }

            if (day) {
                if (!day.start) {
                    return 'Выходной';
                }
                if (day.start == '00:00') {
                    return false;
                } else {
                    return `Сегодня ${day.start} - ${day.end}`;
                }
            }
            return null;
        });

        const setDrugstore = async () => {
            loading.value = true;

            emit('setDrugstore', props.drugstore);

            loading.value = false;
        };

        const setAddress = async () => {
            emit('setAddress', props.drugstore);
        };
        const getRouteToPharmacy = (location)=>{
            window.open(`https://yandex.ru/maps?rtext=~${location.lat},${location.lon}&rtt=auto`, '_blank');

            //window.open(`https://yandex.ru/maps/?mode=routes&rtext=~${location.lat}%2C${location.lon}rtt=auto&ruri=~&z=12`, '_blank');
        };

        return {
            today,
            loading,
            isExpanded,
            setDrugstore,
            currentDrugstoreSchedule,
            setAddress,
            formatAddress,
            getRouteToPharmacy,
        };
    },
};
</script>

<style lang="scss" scoped>
.prod {
    margin-left: 8px;

    &:first-child {
        margin-left: 16px;
    }

    &:last-child {
        margin-right: 16px;
    }
}

.mobile-drugstore {
    border-radius: $mobile-border-radius $mobile-border-radius 0 0 !important;
    box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.15);
}

.day {
    width: 14.2857%;
}

:deep(.q-expansion-item .q-item) {
    font-size: 14px;
    min-height: 0;
    padding-top: 4px;
    padding-bottom: 4px;
}
</style>
